import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    QuotesPdf,
} from './AQuotePdf.types'

type QuotesPdfTable = keyof (QuotesPdf & {
    documentId: number,
})
const columns = ({
    l,
    quotePdfDelete,
    quotePdfUpdate,
}: {
    l: (l:string) => string,
    quotePdfDelete: boolean,
    quotePdfUpdate: boolean,
}): RichTableColumns<QuotesPdfTable>[] => {
    const QuotePdfFields: RichTableColumns<QuotesPdfTable>[] = [
        {
            id: 'filename',
            headerProps: {
                children: l('Document.documentName'),
            },
            mapCellProps: 'filename',
            sorting: false,
        },
        {
            id: 'createdBy',
            headerProps: {
                children: l('AccountQuotes.createdBy'),
            },
            mapCellProps: 'createdBy',
            sorting: false,
        },
        {
            id: 'createdOn',
            headerProps: {
                children: l('Accounts.createdOn'),
            },
            mapCellProps: 'createdOn',
            componentName: 'DateTimeCell',
            sorting: false,
        },
        {
            id: 'description',
            headerProps: {
                children: l('Attachment.description'),
            },
            mapCellProps: 'description',
            sorting: false,
        },
    ]
    const deleteField: RichTableColumns<QuotesPdfTable> = {
        id: 'id',
        mapCellProps: 'id',
        componentName: 'QuotePdfDelete',
        width: '50px',
        sorting: false,
    }
    const updateField: RichTableColumns<QuotesPdfTable> = {
        id: 'documentId',
        mapCellProps: 'id',
        componentName: 'QuotePdfDescriptionEdit',
        width: '35px',
        sorting: false,
    }
    const attachmentField: RichTableColumns<QuotesPdfTable> = {
        id: 'attachmentUrl',
        mapCellProps: 'attachmentUrl',
        componentName: 'DownloadDocument',
        width: '50px',
        sorting: false,
    }

    return [
        ...QuotePdfFields,
        quotePdfUpdate ? updateField : undefined,
        quotePdfDelete ? deleteField : undefined,
        attachmentField,
    ].filter(Boolean)
}

export default columns
